import React, { createContext, useState, useEffect, useCallback } from 'react';
import { shuffleQuestions } from '../utils/helpers';

export const ExamContext = createContext();

export const ExamProvider = ({ children }) => {
  const [selectedSet, setSelectedSet] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [answers, setAnswers] = useState({}); // {questionId: selectedOption}
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [timeLeft, setTimeLeft] = useState(90 * 60); // 90 mins in seconds
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [language, setLanguage] = useState('en'); // 'en' or 'hi'

  // Reset exam state to initial values
  const resetExamState = useCallback(() => {
    setAnswers({});
    setCurrentQuestionIndex(0);
    setTimeLeft(90 * 60);
    setIsSubmitted(false);
    setLanguage('en');
    setSelectedSet(null);
    setQuestions([]);
  }, []);

  // On component mount, sync selectedSet from localStorage once
  useEffect(() => {
    const storedSet = localStorage.getItem('selectedSet');
    if (storedSet) {
      setSelectedSet(storedSet);
    } else {
      resetExamState();
    }
  }, []);

  // Persist selectedSet to localStorage whenever it changes
  useEffect(() => {
    if (selectedSet) {
      localStorage.setItem('selectedSet', selectedSet);
    } else {
      localStorage.removeItem('selectedSet');
    }
  }, [selectedSet]);

  // Fetch questions when set is selected
  useEffect(() => {
    if (selectedSet) {
      fetch(`/Questions_${selectedSet}.json`)
        .then(res => res.json())
        .then(data => setQuestions(shuffleQuestions(data)));
    } else {
      setQuestions([]);
    }
  }, [selectedSet]);

  // Timer logic
  useEffect(() => {
    if (timeLeft > 0 && !isSubmitted) {
      const timer = setInterval(() => setTimeLeft(prev => prev - 1), 1000);
      return () => clearInterval(timer);
    } else if (timeLeft === 0 && !isSubmitted) {
      handleSubmit(); // Auto-submit
    }
  }, [timeLeft, isSubmitted]);

  const handleSubmit = () => {
    setIsSubmitted(true);
    // Scoring logic in helpers.js
  };

  return (
    <ExamContext.Provider value={{
      selectedSet, setSelectedSet,
      questions, answers, setAnswers,
      currentQuestionIndex, setCurrentQuestionIndex,
      timeLeft, language, setLanguage,
      isSubmitted, handleSubmit,
      resetExamState
    }}>
      {children}
    </ExamContext.Provider>
  );
};
